import { LangEnum } from "@alinmaCoreModule/enums/lang.enum";
import { IEnvironmentConfig } from "@alinmaCoreModule/models/environment-config";
import { APP_CONFIG } from "@adminEnvironments/app-config";

export const environment: IEnvironmentConfig = {
  // common config
  ...APP_CONFIG,

  // env
  local     : true,

  // TODO: to be changed

  // security
  "X-IBM-Client-Id"    : "06b53a72b7c80213855ac1e5bc24b508",
  "X-IBM-Client-Secret": "2ecdc7808b2adc36abd440873f55e5d4",
  apiEndpoint: "http://10.0.144.234:9090/", // hesham,
  // connect GW api
  CGWApiEndpoint: "https://api-uat.alinma.internal:9443/alinma-apim-uat/",
  CGWPrefix: "channels-api",
  "X-IBM-Client-Id-CGW-uat": "35029569460fc3d1ad5e07576fbac4ff",
  "X-IBM-Client-Secret-CGW-uat": "4b2b601261e0136d01fee742ff4b6920",
  "X-IBM-Client-Id-CGW-preprod": "ad6b66315df6a8812a2e3d938073edc5",
  "X-IBM-Client-Secret-CGW-preprod": "7d60eb7c3adf02999f560ae8f859b6f9",


  // language
  defaultLang: LangEnum.EN
};
